import {putResolve, takeLeading, select, throttle} from 'redux-saga/effects';
import {
	RESTAURANT_LIST,
	RESTAURANT_LIST_FAILURE,
	RESTAURANT_LIST_REQUEST,
	RESTAURANT_LIST_SUCCESS,
} from 'new-constants/api.constants';
import {getRestaurantList} from 'new-actions/api.actions.ts';
import {SERVER_CONFIG_BY_RESTAURANT_SUCCESS} from "../constants/api.constants";
import {getCurrentAppIdSelector} from "../selectors";

function isRestaurantListNotFetched(restaurantList, currentAppId) {
	if (!restaurantList.cache[currentAppId]) {
		return true;
	}

	return false;
}

function isRestaurantListOutdated(restaurantList, appState) {
	return false;
}

function* getRestaurantListIfNecessary() {
	const state = yield select();
	const {restaurantList, appState, connectivity, fetchProgress} = state;

	if (fetchProgress[RESTAURANT_LIST] || restaurantList.isDataError) {
		return;
	}

	const currentAppId = getCurrentAppIdSelector(state);
	if (

		(isRestaurantListNotFetched(restaurantList, currentAppId) || isRestaurantListOutdated(restaurantList, appState)) &&
		!!currentAppId &&
		connectivity.isOnline !== false
	) {
		yield putResolve(getRestaurantList());
	}
}

function* refreshRestaurantList() {
	const state = yield select();

	yield putResolve(getRestaurantList());
}

export const restaurantListUpdaterSaga = function* restaurantListUpdaterSaga() {
	yield throttle(
		2500,
		[action => ![RESTAURANT_LIST_REQUEST, RESTAURANT_LIST_SUCCESS, RESTAURANT_LIST_FAILURE].includes(action.type)],
		getRestaurantListIfNecessary
	);
	yield takeLeading(
		[SERVER_CONFIG_BY_RESTAURANT_SUCCESS], refreshRestaurantList
	)
};
